import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Only from "react-only-when";
import PriceDisplay from "../../../containers/PriceDisplay";
import { getPropertyItemTitle } from "../../../helpers/general-helpers";
import { LineBreaks, RawHTML } from "../../common";
import { priceNormelizer } from "../../../helpers/tags";
import { Divider } from "../";
import styles from "./styles.less";
// import { getGlobalCurrencyCode, getGlobalCurrency } from "../../../reducers";

const Prices = ({
  isRtl,
  className,
  titles,
  // rooms,
  currency,
  currencyCode,
  selectedCurrency,
  totalPrices,
  clubTotalPrices,
  clubUserLoggedIn,
  propertyType,
  hasPrice,
  isMobileView
}) => {
  const renderPriceOrNone = (price, c, cCode) => {
    if (!price || price == 0) return "-";
    return (
      <div className={styles.value}>
        <PriceDisplay
          price={price}
          currentCurrencyCode={cCode}
          fallBackCurrencySymbol={c}
        >
          {convertedPrice => convertedPrice}
        </PriceDisplay>
      </div>
    );
  };

  const hasAddons = Boolean(
    totalPrices.addonsPrice && totalPrices.addonsPrice > 0
  );

  // const totalPriceNoClub =
  //   totalPrices.roomsNoClubPrice + totalPrices.addonsPrice;

  let isSelectedCurrencyDifferent = false;
  if (selectedCurrency) {
    if (
      (currencyCode == "NIS" || currencyCode == "ILS") &&
      (selectedCurrency == "NIS" || selectedCurrency == "ILS")
    ) {
      isSelectedCurrencyDifferent = false;
    } else {
      isSelectedCurrencyDifferent = currencyCode !== selectedCurrency;
    }
  }

  return (
    <div
      className={cx(styles.prices, className, {
        [styles.rtl]: isRtl,
        [styles.mobileView]: isMobileView
      })}
    >
      <div className={styles.pricesDetails}>
        <div className={styles.rooms}>
          <div>{getPropertyItemTitle(titles, propertyType, true)}:</div>
          <div className={styles.pricesValues}>
            <div
              className={cx({
                [styles.truePrice]: !clubUserLoggedIn,
                [styles.deletedPrice]: clubUserLoggedIn
              })}
            >
              {renderPriceOrNone(
                totalPrices.roomsPrice,
                currency,
                currencyCode
              )}
            </div>
            <Only when={hasPrice && clubUserLoggedIn}>
              <div className={styles.truePrice}>
                {renderPriceOrNone(
                  clubTotalPrices.roomsPrice,
                  currency,
                  currencyCode
                )}
              </div>
            </Only>
          </div>
        </div>
        <Only when={hasAddons}>
          <div className={styles.addons}>
            <div>{titles.Extras}:</div>
            <div className={styles.pricesValues}>
              {renderPriceOrNone(
                totalPrices.addonsPrice,
                currency,
                currencyCode
              )}
            </div>
          </div>
        </Only>
      </div>

      <Divider />

      <div className={cx(styles.totalPrice, { [styles.noPrice]: !hasPrice })}>
        <div className={styles.title}>{titles.TotalPrice}:</div>
        <div>
          <div
            className={cx({
              [styles.truePrice]: !clubUserLoggedIn,
              [styles.deletedPrice]: clubUserLoggedIn
            })}
          >
            {renderPriceOrNone(totalPrices.totalPrice, currency, currencyCode)}
          </div>
          <Only when={hasPrice && clubUserLoggedIn}>
            <div className={styles.truePrice}>
              {renderPriceOrNone(
                clubTotalPrices.totalPrice,
                currency,
                currencyCode
              )}
            </div>
          </Only>
        </div>
      </div>

      <Only when={hasPrice && isSelectedCurrencyDifferent}>
        <div className={styles.priceBefore}>
          <Divider />
          <div className={styles.priceValue}>
            <div className={styles.title}>{titles.PriceBeforeConvertion}:</div>
            <div className={styles.value}>
              {currency}
              {priceNormelizer`${totalPrices.totalPrice}`}
            </div>
          </div>
          <LineBreaks className={cx(styles.notification)}>
            <RawHTML
              html={`* ${titles.CartCurrencyChangedNotification.replace(
                "[CurrencyCode]",
                currency
              )}`}
            />
          </LineBreaks>
        </div>
      </Only>
    </div>
  );
};

Prices.defaultProps = {
  clubUserLoggedIn: false,
  propertyType: "hotel",
  hasPrice: false
};

Prices.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  className: PropTypes.string,
  currency: PropTypes.string,
  currencyCode: PropTypes.string,
  clubUserLoggedIn: PropTypes.bool,
  propertyType: PropTypes.string,
  selectedCurrency: PropTypes.string,
  totalPrices: PropTypes.object,
  hasPrice: PropTypes.bool,
  clubTotalPrices: PropTypes.object,
  isMobileView: PropTypes.bool
};

export default Prices;



// WEBPACK FOOTER //
// ./src/components/Cart/Prices/Prices.js